import { useQuery } from '@apollo/client/react';
import { initQuery } from './query';
export function useGetData(options) {
    return useQuery(initQuery, options);
}
